import React from 'react'
import { Text, View, LessonContextProvider, LessonViewContent } from '@/components'
import { FeedTextOverlay } from '../molecules/TextOverlay'
import { RenderItemProps } from './types'
import { DebugItem, FeedDimensions } from './shared'
import { variantProvider } from '@/app'
import { LessonPaginationIndicator } from '../../Learn/LessonPaginationIndicator'
import { QuizQuestion } from '@/types'
import { locationPath } from '@/utils'
import { analytics, APIClient } from '@/services'
import { tryOpenLesson } from '@/utils/learn'

export const FeedLesson = (props: RenderItemProps) => {
  const { item, contentOverlay } = props
  const lesson = item?.lesson
  const question = lesson?.page?.question as unknown as QuizQuestion

  const currentPage = item?.lesson?.page?.order ?? 1

  function openLesson() {
    locationPath.registerCurrentPath()
    analytics.track('lesson_from_feed')
    tryOpenLesson(lesson.id, currentPage, 'feed')
    return
  }

  return (
    <>
      <DebugItem {...props} />

      {/* <FeedTextOverlay
        title={item.lesson?.title}
        description={item.lesson?.description}
      /> */}
      {contentOverlay}

      <View style={styles.wrapper}>
        <View style={styles.header}>
          <LessonPaginationIndicator pages={item.lesson_page_count + 2} currentPage={currentPage + 1} />
          <Text
            variants={['h5', 'color:neutral1', 'paddingTop:2', 'marginLeft:auto', 'textRight']}
            style={styles.title}
            text={item.lesson.module_title}
          />
        </View>

        <LessonContextProvider>
          <LessonViewContent.Img style={styles.img} question={question} page={lesson?.page} />

          <LessonViewContent.Body question={question} page={lesson?.page} >
            <LessonViewContent.Quiz question={question} page={lesson?.page} />
          </LessonViewContent.Body>

          <LessonViewContent.Video page={lesson?.page} />
        </LessonContextProvider>
      </View>

      <View style={styles.overlay} onClick={openLesson} />

      <LessonViewContent.QuizFeedback question={question} onNext={openLesson} />
    </>
  )
}

const styles = variantProvider.createComponentStyle(theme => ({
  wrapper: {
    height: FeedDimensions.HEIGHT,
    width: FeedDimensions.WIDTH,
    ...theme.presets.center,
    ...theme.presets.relative,
    ...theme.spacing.padding(2),
    pointerEvents: 'none',

    [theme.media.down(FeedDimensions.mobileBreakpoint)]: {
      width: FeedDimensions.WIDTH_WITHOUT_SPACING,
      height: FeedDimensions.HEIGHT_WITHOUT_SPACING,
    }
  },
  header: {
    ...theme.presets.column,
    ...theme.presets.absolute,
    top: theme.spacing.value(2),
    right: theme.spacing.value(2),
    left: theme.spacing.value(2),
  },
  img: {
    ...theme.presets.fullWidth,
    objectFit: 'contain',
  },
  title: {
    width: '80%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  overlay: {
    ...theme.presets.absolute,
    ...theme.presets.whole,
    zIndex: 3,
    cursor: 'pointer',
  },
}), true)
